var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageHeaderBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1300 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    preserveAspectRatio: "none",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "curve-green",
    d: "M0,4l0,170.167c0,-0 30.516,15.266 68.4,14.395c69.503,-1.599 129.322,-45.578 202.106,-84.562c154.869,-82.95 329.494,-100 329.494,-100l-600,-0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "curve-blue2",
    d: "M-2.274,1.157l-0.074,115.837c0,-0 30.131,15.236 71.936,17.786c65.142,3.973 162.316,-9.675 246.396,-58.284c125.773,-72.711 284.016,-72.496 284.016,-72.496l0,-2.48l-602.274,-0.363Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "curve-blue2",
    d: "M1299,3.351l1,168.903c0,0 -71.327,-59.241 -204.679,-97.358c-130.437,-37.283 -180.253,-41.208 -180.253,-41.208l383.932,-30.337Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "curve-green",
    d: "M1300,4l0,143.091c0,-0 -51.032,-34.072 -184.385,-72.189c-130.436,-37.284 -415.615,-70.902 -415.615,-70.902l600,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "curve-blue1",
    d: "M700,-0.48l0,-0.52l601,0l0,88.803c0,-0 -130.254,-31.773 -197.886,-41.963c-107.66,-16.221 -403.114,-41.84 -403.114,-41.84c0,0 -26.039,-0.843 -50,-0.843c-23.961,0 -50,0.843 -50,0.843c0,0 -158.243,-0.215 -284.016,72.496c-84.08,48.609 -181.254,49.029 -246.396,45.056c-41.805,-2.55 -71.936,-29.997 -71.936,-29.997l0.074,-92.398l602.274,0.363l100,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageHeaderBottom);
export default __webpack_public_path__ + "static/media/pageHeaderBottom.535148b7c482fe67352a9dafab1e02c9.svg";
export { ForwardRef as ReactComponent };